import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-header-bar-action>` is a component that renders a header-bar action
 */
@Component({
  selector: 'labs-header-bar-action',
  template: '<ng-content></ng-content>',
  styleUrls: ['./header-bar-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderBarActionComponent {}
